<template>
  <div>
    <div class="bg-white">
      <div class="flex justify-between items-center">
        <v-btn text @click="close" class="my-2">
          <v-icon> mdi-close </v-icon>
        </v-btn>
        <v-btn text @click="send_email">
          <v-icon> mdi-send </v-icon>
        </v-btn>
      </div>
      <!-- {{ attachments }} -->
      <v-card color="#F2EEF3">
        <v-card-title primary-title>
          <v-progress-linear
            v-if="progressbar"
            :indeterminate="indeterminate"
          ></v-progress-linear>
          <div class="w-full justify-between flex">
            <div>Customer Service Email Sender</div>
            <div>
              <v-icon @click="on_attach_file"> mdi-attachment </v-icon>
            </div>
            <input
              type="file"
              ref="attachmentInput"
              @change="on_attachment_uploaded"
              style="display: none"
              multiple
            />
          </div>
        </v-card-title>
        <v-card-text>
          <div class="mb-4">
            <div class="w-full flex flex items-center">
              <div
                class="
                  w-[58px]
                  text-right
                  justify-end
                  items-center
                  flex
                  mr-2
                "
              >
                To:
              </div>
              <div class="border-gray-400 w-full rounded border">
                <input
                  class="bg-white rounded px-4 w-full py-1"
                  type="text"
                  placeholder="Email address"
                  v-model="email_address"
                />
              </div>
            </div>
            <div class="w-full flex flex items-center">
              <div class="max-w-[50px] text-right flex items-center mr-2">
                Subject:
              </div>
              <div class="border-gray-400 w-full rounded border">
                <input
                  class="bg-white rounded px-4 w-full py-1"
                  type="text"
                  placeholder="Subject"
                  v-model="subject"
                />
              </div>
            </div>
          </div>
          <!-- email_content -->
          <div class="email-content">
            <vue-editor v-model="email_content"></vue-editor>
          </div>
          <div v-if="showAttachments" class="bg-white p-2">
            <v-icon>mdi-attachment</v-icon>
            {{ totalAttachments }} attachment{{ plural }}
            <div v-for="(item, i) in attachments" :key="i">
              {{ item.name }}
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-snackbar top v-model="snackbar">
        {{ snackbarText }}
        <v-btn text color="primary" @click.native="snackbar = false"
          >Close</v-btn
        >
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus";
import { VueEditor } from "vue2-editor";
import axios from "axios";
export default {
  components: { VueEditor },
  // props: ["open_email"],
  data() {
    return {
      maxLimit: "",
      plural: "",
      totalAttachments: 0,
      showAttachments: false,
      progressbar: false,
      indeterminate: false,
      email_content: "",
      email_address: "",
      subject: "",
      snackbar: false,
      snackbarText: "",
      attachments: [],
    };
  },
  methods: {
    async getMaxLimit() {
      try {
        const response = await axios.get("/email/max_limit");
        if (response.data && response.data.length > 0) {
          this.maxLimit = response.data[0].size;
        } else {
          // Set a default max limit (in bytes, e.g., 5MB = 5 * 1024 * 1024)
          this.maxLimit = 5 * 1024 * 1024;
          console.warn("No email_max_limit found, using default value");
        }
      } catch (error) {
        console.error("Error fetching max limit:", error);
        // Set default value in case of error
        this.maxLimit = 5 * 1024 * 1024;
      }
    },
    progressBar(e) {
      this.progressbar = e;
      this.indeterminate = e;
    },
    send_email() {
      if (!this.email_content || !this.email_address || !this.subject) {
        this.snackbar = true;
        this.snackbarText = "Please complete the required fields";
      } else {
        this.progressBar(true);
        const data = new FormData();
        data.append("email", this.email_address);
        data.append("subject", this.subject);
        data.append("HTML", this.email_content);
        this.attachments.forEach((att) => data.append("attachments", att));

        axios
          .post("/email/send", data)
          .then((res) => {
            if (res.data.status) {
              this.progressBar(false);
              EventBus.$emit("GetEmailsAnonymous");
              alert("Email sent!");
              this.close();
            }
          })
          .catch((err) => console.log(err));
      }
    },
    on_attach_file() {
      alert(
        `Choose the file to attach. Limited to ${parseInt(this.maxLimit) /
          1000000} MB per file size.`
      );
      this.$refs?.attachmentInput?.click();
    },
    on_attachment_uploaded(e) {
      this.progressBar(true);
      if (!e.target.files?.length) {
        return;
      } else {
        const fileSize = e.target.files[0].size;
        if (fileSize > parseInt(this.maxLimit)) {
          return alert(
            `Select file to upload - max file size = ${parseInt(this.maxLimit) /
              1000000}MB only`
          );
        } else {
          this.attachments = e.target.files;
          this.totalAttachments = this.attachments.length;
          if (this.totalAttachments > 1) {
            this.plural = "s";
          } else {
            this.plural = "";
          }
          this.showAttachments = true;
          this.progressBar(false);
        }
      }
    },
    close() {
      this.email_content = "";
      this.$emit("close_email_dialog");
      this.attachments = [];
      this.showAttachments = false;
      this.totalAttachments = 0;
      this.email_address = "";
      this.subject = "";
    },
  },
  watch: {
    "$route.name": {
      async handler() {
        await this.getMaxLimit();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
/* src/assets/styles.css */
.email-content p {
  line-height: 1; /* Adjust this value as needed */
  margin: 0;
}
</style>
